const currencyMap = {
    USD: "USD",
    ARS: "AR$",
};

export default function Stats({ title, currency, value }) {
    return (
        <div className="cot-stats">
            <div className="title small-text">{title}</div>

            <div className="value">
                <span className="tag">{currencyMap[currency]}</span>
                <span className="paragraph">{value}</span>
            </div>
        </div>
    );
}

export function StatsBig({ title, value, currency }) {
    // console.log(currencyMap);
    return (
        <div className="cot-stats cot-stats-big">
            <div className="title title-4">{title}</div>

            <div className="value">
                {value && <span className="tag">{currencyMap[currency]}</span>}
                {value && <span className="paragraph">{value}</span>}
            </div>
        </div>
    );
}
